import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    position: String,
    delay: Object,
  };

  connect() {
    $(this.element).popup({
      position: this.positionValue,
      delay: this.delayValue,
    });
  }

  disconnect() {
    $(this.element).popup("destroy");
  }
}
